import { useEffect, useMemo, useState } from 'react';
import {
  type Photo,
  type RecordedRoute,
  fetchAndParse,
  photoManifestSchema,
  recordedRouteSchema,
} from '../schemas';

export function useTrailData() {
  const [route, setRoute] = useState<RecordedRoute | null>(null);
  const [photos, setPhotos] = useState<Photo[]>([]);

  useEffect(() => {
    let active = true;
    void Promise.allSettled([
      fetchAndParse('/data/recorded-route.geojson', recordedRouteSchema),
      fetchAndParse('/data/photos.json', photoManifestSchema),
    ]).then(([routeResult, photoResult]) => {
      if (!active) return;
      if (routeResult.status === 'fulfilled') setRoute(routeResult.value);
      if (photoResult.status === 'fulfilled') setPhotos(photoResult.value.media);
    });
    return () => {
      active = false;
    };
  }, []);

  const activitiesByDate = useMemo(
    () =>
      new Map(route?.features.map((feature) => [feature.properties.date, feature.properties] as const) ?? []),
    [route],
  );
  const activitiesById = useMemo(
    () =>
      new Map(
        route?.features.map((feature) => [feature.properties.activity_id, feature.properties] as const) ?? [],
      ),
    [route],
  );

  return { route, photos, activitiesByDate, activitiesById };
}
